/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {Stuffid} from '../../core/_models'

type Props = {
  data: Stuffid
}

const StuffidRateCell: FC<Props> = ({data}) => {
  let inlineClass = 'text-success'
  if ((data.rt || 0) > 0) {
    inlineClass = 'text-danger'
  }
  return <span className={clsx(inlineClass, 'text-center w-100')}>{data.rt}%</span>
}

export {StuffidRateCell}
